import React from "react"
import { useDispatch } from "react-redux"
import { deleteCustomName } from "reduxSlices/customNamesSlice"
import { CustomNameShape } from "utils/propTypeShapes"
import { customNameInSentence, DEFAULT_NAMES } from "utils/customNameHelpers"
import ItemRow from "shared/ItemRow"
import { CircularIconButton } from "shared/buttons"
import CustomNamesListItemNameSection from "./CustomNamesListItemNameSection"

const CustomNamesListItem = ({ customName }) => {
  const dispatch = useDispatch()
  const { key, name } = customName

  const defaultName = DEFAULT_NAMES[key]

  const confirmDeleteMessage = `Are you sure you want to delete the custom name "${name}"?`
    + "\n\n"
    + `The organization will go back to using "${defaultName}".`

  const deleteName = () => {
    if (window.confirm(confirmDeleteMessage)) {
      dispatch(deleteCustomName({ key }))
    }
  }

  return (
    <ItemRow
      collapsable
      itemRowHeaderContent={(
        <>
          <span>{name}</span>
          <span className="text-xs text-dark">
            replaces
            {" "}
            {customNameInSentence(defaultName)}
          </span>
        </>
      )}
      itemRowHeaderControls={(
        <CircularIconButton ariaLabel={`Delete the custom name "${name}"`} icon="close" onClick={deleteName} />
      )}
      itemRowBody={(
        <CustomNamesListItemNameSection customName={customName} />
      )}
    />
  )
}

CustomNamesListItem.propTypes = {
  customName: CustomNameShape.isRequired,
}

export default CustomNamesListItem
